var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.26 46H34V48H24V47C24 44.5 26.238 42.822 28.4 41.2C30.17 39.872 32 38.5 32 37C32 35.346 30.654 34 29 34C27.346 34 26 35.346 26 37H24C24 34.244 26.244 32 29 32C31.756 32 34 34.244 34 37C34 39.5 31.762 41.178 29.6 42.8C28.23 43.828 26.826 44.882 26.26 46ZM46 40H41C40.448 40 40 39.552 40 39V32H38V39C38 40.654 39.346 42 41 42H46V48H48V32H46V40ZM46 6V14.432C42.218 5.752 33.546 0 24 0C10.766 0 0 10.766 0 24C0 33.99 6.29 43.036 15.652 46.508C17.062 47.032 18.522 47.364 20 47.612V45.596C18.76 45.368 17.534 45.074 16.348 44.634C7.766 41.45 2 33.158 2 24.002C2 11.87 11.87 2 24 2C33.03 2 41.21 7.614 44.488 16H36V18H45C46.654 18 48 16.654 48 15V6H46ZM26 11H24V24H13V26H26V11Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/availability.450d127d7a2ca8b67fbc822828cbf690.svg";
export { ForwardRef as ReactComponent };